// extracted by mini-css-extract-plugin
module.exports = {"header":"CommDesktopPreview_header__23jP1","body":"CommDesktopPreview_body__7j5KQ"};